import React from 'react';
import { ApolloProvider, gql, useQuery } from '@apollo/client';
import client from '../lib/apolloClient';
import { SucceedoDashboardLoader } from './SucceedoDashboardContainer';
import { ARTIFACT_FIELDS } from './SucceedoGeorgeContainer';
import ArtifactLibrary from '../components/Succeedo/Conversation/ArtifactLibrary';

// The owner's latest saved results, plus the coach's name for the library
// copy (null until the conversation has started).
export const WORKSPACE_ARTIFACTS = gql`
  query WorkspaceArtifacts {
    my_artifacts {
      ...CoachArtifactFields
    }
    coaching_conversation {
      id
      coach_name
    }
  }
  ${ARTIFACT_FIELDS}
`;

export function askGeorgeHref(artifact) {
  return `/succeedo/george?ask=${encodeURIComponent(artifact.kind)}`;
}

// "Ask <coach> about this" opens the conversation with the artifact named in
// the composer (the George container reads ?ask=<kind>).
function askAbout(artifact) {
  if (window.ahoy) window.ahoy.track('succeedo_george_artifact_ask', { kind: artifact.kind, from: 'workspace' });
  window.location.href = askGeorgeHref(artifact);
}

// The artifact library's data.
export function WorkspaceArtifacts() {
  const { data, loading, error } = useQuery(WORKSPACE_ARTIFACTS, { fetchPolicy: 'cache-and-network' });
  return (
    <ArtifactLibrary
      artifacts={data?.my_artifacts || []}
      coachName={data?.coaching_conversation?.coach_name || undefined}
      loading={loading && !data}
      error={!!error && !data}
      onAsk={askAbout}
    />
  );
}

// The Workspace (P1-10, PRD §6.4): the artifact library on top of the
// former dashboard (summary strip, Succession Team, tools, top actions).
export default function SucceedoWorkspaceContainer() {
  return (
    <ApolloProvider client={client}>
      <SucceedoDashboardLoader mode="workspace" topSlot={<WorkspaceArtifacts />} />
    </ApolloProvider>
  );
}
